const PERTH_TZ = 'Australia/Perth';

/**
 * Format a date string as dd/MM/yyyy in Perth timezone
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: PERTH_TZ });
  } catch { return dateStr; }
};

/**
 * Format a date string as dd Mon yyyy in Perth timezone (e.g. "08 Apr 2026")
 */
export const formatDateShort = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric', timeZone: PERTH_TZ });
  } catch { return dateStr; }
};

/**
 * Format a date string as "Monday 08 Apr" in Perth timezone
 */
export const formatDateLong = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-AU', { weekday: 'long', day: '2-digit', month: 'short', timeZone: PERTH_TZ });
  } catch { return dateStr; }
};

/**
 * Format a datetime string as "dd/MM/yyyy, hh:mm:ss am/pm" in Perth timezone
 */
export const formatDateTime = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleString('en-AU', { timeZone: PERTH_TZ });
  } catch { return dateStr; }
};

/**
 * Relative time ago string using Perth timezone
 */
export const timeAgo = (dateStr) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return 'just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    return `${Math.floor(diff / 86400)}d ago`;
  } catch { return ''; }
};

/**
 * Get today's date in Perth timezone as yyyy-MM-dd string
 */
export const getPerthToday = () => {
  const now = new Date();
  const parts = now.toLocaleDateString('en-CA', { timeZone: PERTH_TZ }); // en-CA gives yyyy-MM-dd
  return parts;
};

/**
 * Get a date N days from now in Perth timezone as yyyy-MM-dd
 */
export const getPerthDateOffset = (days) => {
  const now = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
  return now.toLocaleDateString('en-CA', { timeZone: PERTH_TZ });
};
